import Copy from './commands/store/copy.js'

const COMMANDS = {
  'store:copy': Copy,
}

export default COMMANDS
